import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './BudgetSummaryTable.html?raw';
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import SpreadsheetTable from '../../moreCore/UI/Spreadsheet/SpreadsheetTable';
import lang from 'dojo/_base/lang';
import "../../moreCore/UI/Button/Button";
import { StringHelpers, TranslationHelpers } from "../../more/Helpers";


interface BudgetSummmaryTableConfiguration {
    data: {
        infotextCM: string;
        infotext100: string;
        isCMmissing: boolean;
        rows: BudgetSummmaryRow[],
        missingProjectsCM: Array<string>
        isBudgetsMissing: boolean;
        missingProjectsBudget: Array<string>
    },
    config: SpreadsheetTableTypes.SpreadsheetConfig<BudgetSummmaryRow>;
}

interface BudgetSummmaryRow {

}

class BudgetSummaryTable extends compose(_uiFrameMixin) {
    templateString: any = template;

    private summaryTable: MdsLax<InstanceType<typeof SpreadsheetTable<BudgetSummmaryRow>>>
    private tableData: BudgetSummmaryTableConfiguration;
    private reloadConfig: any;

    private spreadsheetContainer: HTMLElement;
    private missingProjectsContainer: HTMLElement;
    private missingProjectsContent: HTMLElement;
    private missingProjectsBudgetContent: HTMLElement;
    private missingBudgetsContainer: HTMLElement;
    

    setup(rosterConfig) {
        if (rosterConfig) {
            this.reloadConfig = lang.clone(rosterConfig);
        }

        if (this.reloadConfig) {
            this.addButtonEx({
                internalName: "reload",
                callback: lang.hitch(this, this._loadConfigurationData),
                label: "General_Reload",
                iconClass: "fas fa-sync"
            });
        }

        if (this.isActive) {
            this._loadConfigurationData();
        }
    }

    protected onShow() {
        
    }

    protected onExpand(state: boolean) {

    }

    private _loadConfigurationData() {
        
        this.StandbyStart();

        let data = this.reloadConfig;

        this.RequestManager.callfunction("Webtool_API_BudgetCalculationRoster__LoadSummaryTable",
            data,
            lang.hitch(this, this._onLoadConfigurationResponse, true),
            lang.hitch(this, this._onLoadConfigurationResponse, false),
        );
    }

    private _onLoadConfigurationResponse(success: boolean, response) {

        this.disableNode(this.spreadsheetContainer, !success);

        this.StandbyStop();


        if (success === true) {
            this._setConfigurationData(response);
        } else {
            let error = response as more.requestErrorMessage;
            this.showToast({
                title: "error loading configuration",
                message: error.Message,
                iconClass: toasterIcons.error
            });
        }
    }


    private _setConfigurationData(tableData: BudgetSummmaryTableConfiguration) {

        if (typeof tableData != "object" || !tableData) return;
        //this.costCalculationTable = null;
        //this.priceScaleTable = null;

        this.tableData = tableData;

        if (tableData.config) {
            this.UiModder.domConstruct.empty(this.spreadsheetContainer);

            if (!tableData.data?.rows?.length) {

                let infoP = this.UiModder.domConstruct.create("p", {
                    className: "infoBG",
                    innerHTML: TranslationHelpers.translate("BudgetCalculation_Message__NoCostEntitiesInProject")
                }, this.spreadsheetContainer);

              

            } else {

                this.summaryTable = new SpreadsheetTable();

                tableData.config.headerStyleFormatter = lang.hitch(this, this._headerFormatter);
                tableData.config.cellStyeFormatter = lang.hitch(this, this._cellFormatter);
                
                this.summaryTable.show("node", this.spreadsheetContainer);
                this.summaryTable.setup(tableData.config, tableData.data.rows);

                this.disableNode(this.spreadsheetContainer, false);
            }
        }

        if (tableData.data.missingProjectsCM?.length) {
            this.hideNode(this.missingProjectsContainer, false);
            this.UiModder.domAttr.set(this.missingProjectsContent, "innerHTML", tableData.data.missingProjectsCM.join("<br>"));
        } else {
            this.hideNode(this.missingProjectsContainer);
        }

        if (tableData.data.missingProjectsBudget?.length) {
            this.hideNode(this.missingBudgetsContainer, false);
            this.UiModder.domAttr.set(this.missingProjectsBudgetContent, "innerHTML", tableData.data.missingProjectsBudget.join("<br>"));
        } else {
            this.hideNode(this.missingBudgetsContainer);
        }


        this._handleButtons();
    }

    private _cellFormatter(cell: SpreadsheetTableTypes.DataCell<BudgetSummmaryRow>): SpreadsheetTableTypes.cellFormatterResult {
        let result = this._headerFormatter(cell.column) as SpreadsheetTableTypes.cellFormatterResult;

        if (result) {
            //result.overrideInfotext = "nicht alle DB erfasst";
        } else {
            result = {
                styleTemplate: "default"
            };
        }

        let cellValue = cell.value as number;
        if (cell.row.rowID != "sumCost") {
            if (typeof cell.value == "number") {
                result.overrideDisplayValue = cellValue.toFixed(0);
            } else {
                result.overrideDisplayValue = "-";
            }
        } else {
            result.overrideDisplayValue = "€ " + StringHelpers.numberToString(cellValue, 1, 2);
        }
        if (cell.column.columnID == "colCM" && cell.row.rowID == "sumCost") {
            if (this.tableData.data.infotextCM) result.overrideInfotext = this.tableData.data.infotextCM;
        }
        else if (cell.column.columnID == "col100" && cell.row.rowID == "sumCost") {
            if (this.tableData.data.infotext100) result.overrideInfotext = this.tableData.data.infotext100;
        }

        return result;
    }

    private _headerFormatter(col: SpreadsheetTableTypes.Column<BudgetSummmaryRow>): SpreadsheetTableTypes.columnFormatterResult {
        if (col.columnID == "colCM") {
            let result: SpreadsheetTableTypes.columnFormatterResult = {
                styleTemplate: "default"
            };
            if (this.tableData.data.isCMmissing) {
                result.styleTemplate = "warning";
            }

            return result;
        }
        else if (col.columnID == "col100") {
            let result: SpreadsheetTableTypes.columnFormatterResult = {
                styleTemplate: "default"
            };
            if (this.tableData.data.isBudgetsMissing) {
                result.styleTemplate = "warning";
            }

            return result;
        }
        return false;
    }

    private _handleButtons() {
        
    }

    invalidate(bInvalidate: boolean = true): void {
        //this.disableNode(this.spreadsheetContainer, bInvalidate !== false);
        
        this.summaryTable.invalidateCell(this.summaryTable.getCells(), bInvalidate !== false);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.title = TranslationHelpers.translate("BudgetCalculationRoster_Label__SummaryTable");
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(BudgetSummaryTable);